import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

let sharedSocket = null;
let sharedToken = null;
let referenceCount = 0;

function connectToSocket() {
  const token = localStorage.getItem("token");

  if (!sharedSocket || sharedToken !== token) {
    if (sharedSocket) {
      sharedSocket.disconnect();
    }

    sharedToken = token;
    referenceCount = 0;

    sharedSocket = openSocket(getBackendUrl(), {
      transports: ["websocket", "polling", "flashsocket"],
      query: {
        token: JSON.parse(token),
      },
    });
  }

  const socket = sharedSocket;
  referenceCount += 1;

  const listeners = [];
  let released = false;
  let proxy;

  const release = () => {
    if (released) return proxy;

    released = true;

    listeners.forEach(({ event, listener }) => {
      socket.off(event, listener);
    });

    listeners.length = 0;
    referenceCount = Math.max(0, referenceCount - 1);

    if (referenceCount === 0 && sharedSocket === socket) {
      socket.disconnect();
      sharedSocket = null;
      sharedToken = null;
    }

    return proxy;
  };

  proxy = new Proxy(socket, {
    get(target, prop) {
      if (prop === "on") {
        return (event, listener) => {
          target.on(event, listener);
          listeners.push({ event, listener });
          return proxy;
        };
      }

      if (prop === "once") {
        return (event, listener) => {
          target.once(event, listener);
          listeners.push({ event, listener });
          return proxy;
        };
      }

      if (prop === "off") {
        return (event, listener) => {
          if (listener) {
            target.off(event, listener);

            for (let i = listeners.length - 1; i >= 0; i -= 1) {
              if (
                listeners[i].event === event &&
                listeners[i].listener === listener
              ) {
                listeners.splice(i, 1);
              }
            }
          } else {
            for (let i = listeners.length - 1; i >= 0; i -= 1) {
              if (listeners[i].event === event) {
                target.off(listeners[i].event, listeners[i].listener);
                listeners.splice(i, 1);
              }
            }
          }

          return proxy;
        };
      }

      if (
        prop === "disconnect" ||
        prop === "close"
      ) {
        return release;
      }

      const value = target[prop];

      if (typeof value === "function") {
        return value.bind(target);
      }

      return value;
    },

    set(target, prop, value) {
      target[prop] = value;
      return true;
    },
  });

  return proxy;
}

export default connectToSocket;
